import KeyboardShortcuts from "./KeyboardShortcuts";

export default KeyboardShortcuts;
